import {handleActions} from 'redux-actions';

import {AUTO_LOGIN} from '/enum/biometrics.enum';
import {withPayload} from '/util/reducer.util';

import setAutoLoginState from './biometrics/setAutoLoginState';
const initialState = {
  autoLoginBiometrics: true,
};

export default handleActions(
  {
    [AUTO_LOGIN]: withPayload(setAutoLoginState),
  },
  initialState,
);
